import { useEffect } from 'react';

export const useArrowNavigation = (onLeft: () => void, onRigth: () => void, isDisabled?: boolean) => {
    useEffect(() => {
        if (isDisabled) {
            return;
        }

        let handleKeyPress: (event: KeyboardEvent) => void = (event: KeyboardEvent) => {
            if (event.key === 'ArrowLeft') {
                onLeft();
            }
            if (event.key === 'ArrowRight') {
                onRigth();
            }
        };

        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);

        // remove the event listener
        return () => {
            if (handleKeyPress) {
                document.removeEventListener('keydown', handleKeyPress);
            }
        };
    }, [onLeft, onRigth, isDisabled]);
};
